<template>
    <v-row class="d-flex px-8 py-4 align-end">
        <v-col v-if="mealTypeNameItems.length > 1" cols="12" md="2">
            <v-select
                :items="mealTypeNameItems"
                :label="$t('filterTitles.mealTypes')"
                :closable-chips="false"
                :model-value="availability"
                :multiple="false"
                name="mealTypeName"
                item-title="name"
                hide-details
                clearable
                item-value="value"
                density="compact"
                @update:model-value="change($event, 'mealTypeName')"
            />
        </v-col>
        <v-col v-if="availabilityItems.length > 1" cols="12" md="2">
            <v-select
                :items="availabilityItems"
                :label="$t('filterTitles.availability')"
                :closable-chips="false"
                :model-value="availability"
                :multiple="false"
                name="availability"
                item-title="name"
                clearable
                hide-details
                item-value="value"
                density="compact"
                @update:model-value="change($event, 'availability')"
            />
        </v-col>
        <v-col v-if="cabinTypeNameItems.length > 1" cols="12" md="2">
            <v-select
                :items="cabinTypeNameItems"
                :label="$t('filterTitles.cabinType')"
                :closable-chips="false"
                :model-value="availability"
                :multiple="false"
                name="cabinType"
                hide-details
                item-title="name"
                clearable
                item-value="value"
                density="compact"
                @update:model-value="change($event, 'cabinType')"
            />
        </v-col>
        <v-col v-if="datesForFilter.length > 1" cols="12" md="2">
            <date-filter-search
                v-model="dateFilter"
                :dates-for-filter="datesForFilter"
                @update:model-value="onDateFilterChange"
            />
        </v-col>
        <v-col cols="12" md="2">
            <sort-select v-model="sortKey" :items="sortItems" class="mb-n5" />
        </v-col>
        <v-col cols="12" md="2">
            <group-offers-select
                :items="['none', 'serviceName', 'mealTypeName', 'startDate']"
                :product-store="productStore"
                hide-details
                token-base="cruiseGroupBy"
            />
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop} from 'vue-facing-decorator'
    import SelectOption from '@/components/snippets/AdditionalSearchOptions/SelectOption.vue'
    import GroupOffersSelect from '@/components/search/GroupOffersSelect.vue'
    import {CruisesStoreMixin} from '@/mixins/CruisesStoreMixin.vue'
    import DateFilterSearch from '@/components/snippets/DateFilterSearch.vue'
    import SortSelect from '@/components/search/SortSelect.vue'

    @Component({
        components: {
            SortSelect,
            DateFilterSearch,
            GroupOffersSelect,
            SelectOption,
        },
    })
    export class CruisePageFilters extends mixins(CruisesStoreMixin) {
        @Prop({required: true}) offers
        @Prop({required: true}) datesForFilter

        availability = null
        availabilityItems = []
        mealTypeNameItems = []
        cabinTypeNameItems = []
        dateFilter = null

        mounted() {
            this.setAvailabilityItems()
            this.setMealTypeNameItems()
            this.setCabinTypeNameItems()
        }

        @Emit()
        change(value, key) {
            return value ? {value: [value], key} : {value: [], key}
        }

        @Emit()
        onDateFilterChange(date) {
            return date
        }

        setAvailabilityItems() {
            this.availabilityItems = [...new Set(this.offers.map(item => item.available))].map(available => {
                const value = available ? 'available' : 'on_request'

                return {name: this.$t(`${value}`), value}
            })
        }

        setMealTypeNameItems() {
            this.mealTypeNameItems = [...new Set(this.offers.map(item => item.mealTypeName))].map(mealTypeName => {
                return {
                    name: this.$t(`${mealTypeName}`),
                    value: mealTypeName,
                }
            })
        }

        setCabinTypeNameItems() {
            this.cabinTypeNameItems = [...new Set(this.offers.map(item => item.serviceName))].map(serviceName => {
                return {
                    name: this.$t(`${serviceName}`),
                    value: serviceName,
                }
            })
        }

        get sortKey() {
            return cruisesStore.sortFnName
        }

        set sortKey(sortKey) {
            cruisesStore.SET_SORT(sortKey)
        }
        get sortItems() {
            return [
                {
                    text: this.$t('sort.price_asc'),
                    value: 'priceAsc',
                },
                {
                    text: this.$t('sort.price_desc'),
                    value: 'priceDesc',
                },
                {
                    text: this.$t('sort.date_asc'),
                    value: 'dateAsc',
                },
            ]
        }
    }

    export default CruisePageFilters
</script>

<style lang="scss" scoped>
    :deep(.v-input) {
        margin-top: 0;
    }
</style>
